import React, { Component } from 'react';
import { BarLoader } from 'react-spinners';
import EventTeaser from './EventTeaser';
import EventPaginator from './EventPaginator';
import Reset from "../components/Reset"
import './Events.css'

class Events extends Component
{
    render() {


        if (!this.props.events.data) {
            return <div className={'row'}>
                <div className={'col-md-12'}>
                    <BarLoader/>
                </div>
            </div>
        }

        if (this.props.events.total === 0) {
            return <div className={'row'}>
                <div className={'col-md-12'}>
                    <div className={'row'}>
                        <div className={'col-sm-8'}>
                            <strong>Keine Veranstaltungen gefunden</strong>
                        </div>
                    </div>
                </div>
            </div>
        }

        return <div className={'row'}>
            <div className={'col-md-12'}>
                <div className={'row'}>
                    <div className={'col-sm-8'}>
                        <h2 className={'subline'}><strong>{this.props.events.total}</strong> Veranstaltungen gefunden</h2>
                    </div>
                </div>
                <hr />
                <ul className={'aktuelle-termine'}>
                    {
                        this.props.events.data.map(
                            event => <EventTeaser key={event.id} event={event} fulltext={this.props.fulltext} />
                        )
                    }
                </ul>
                <EventPaginator eventData={this.props.events} appendEventsNextPage={this.props.appendEventsNextPage} eventsAdding={this.props.eventsAdding} />
            </div>
        </div>
    }
}

export default Events




// WEBPACK FOOTER //
// ./src/components/Events.js